import {
  Option,
  OptionPageQuery,
  OptionResource,
  OptionResourcePage,
  OptionResourcePayload,
  PageOf
} from '@/models'

import {
  generateCreate,
  generateDelete,
  generateRead,
  generateReadPage,
  generateUpdate
} from '../crudGenerator'

/**
 * Converts OptionResource to Option.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOptionResource (resource: OptionResource): Option {
  return {
    id: resource.id,
    name: resource.name,
    description: resource.description,
    price: resource.price,
    isAvailable: resource.available // Renaming
  }
}

/**
 * Converts OptionResourcePage to PageOf<Option>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOptionResourcePage (page: OptionResourcePage): PageOf<Option> {
  return {
    elements: page.options.map(parseOptionResource),
    total: page.count
  }
}

const url = '/menu'
const entity = 'options'

export default {
  /**
   * Creates a new Option.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createOption: generateCreate<Option, OptionResource, OptionResourcePayload>(url, entity, parseOptionResource),

  /**
   * Deletes an Option.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Option id to be deleted.
   */
  deleteOption: generateDelete(url, entity),

  /**
   * Gets an Option.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Option id to be fetched.
   */
  fetchOption: generateRead(url, entity, parseOptionResource),

  /**
   * Gets a page of Options.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query options.
   */
  fetchOptionPage: generateReadPage<Option, OptionResourcePage, OptionPageQuery>(url, entity, parseOptionResourcePage),

  /**
   * Updates an existing Option.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id Option id to be updated.
   * @param payload Data required to create it.
   */
  updateOption: generateUpdate<Option, OptionResource, OptionResourcePayload>(url, entity, parseOptionResource)
}
